var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.reseller)?_c('a',{on:{"click":_vm.mailToReseller}},[_c('SupportIcon')],1):(_vm.item.model.code === 'bluegrass-fields' || _vm.item.model.code === 'anafi-work')?_c('a',{on:{"click":_vm.parrotSupport}},[_c('SupportIcon')],1):_c('a',{on:{"click":_vm.openZendeskSupportUrl}},[_c('SupportIcon')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d67491c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/ProductSupportLink/ProductSupportLink.vue
// module id = null
// module chunks = 